import { render, staticRenderFns } from "./CollectDefaultFilter.vue?vue&type=template&id=341454b6&scoped=true"
import script from "./CollectDefaultFilter.vue?vue&type=script&lang=js"
export * from "./CollectDefaultFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341454b6",
  null
  
)

export default component.exports